<br>
<div style="text-align:center">
    <img width="10%" *ngIf="_storage.getItem('company') =='1'" src="../assets/logo_emm_retina.png">
    <img width="5%" *ngIf="_storage.getItem('company') =='2'" src="../assets/diemmegi.jpg">
</div>
<br>
<button mat-raised-button color="primary" (click)="newrole()">
    <mat-icon>fiber_new</mat-icon>
</button>
<button mat-raised-button color="primary" (click)="back()">Back
    <mat-icon>keyboard_backspace</mat-icon>
</button>
<mat-card class="example-card" style="width: 100%; background-color: rgb(153, 218, 238)">
    <mat-table *ngIf="update_web == 'false'" style="border: 1px;border-color: black;border-style: solid"
        [dataSource]="dataSource" style="width: 100%">
        <ng-container matColumnDef="Role">
            <mat-header-cell *matHeaderCellDef>Role</mat-header-cell>
            <mat-cell *matCellDef="let row">{{row.Role}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row">
                <button mat-raised-button color="warn" (click)="delete(row.id)">
                    <mat-icon >delete_forever</mat-icon>
                    <mat-icon style="color: green" *ngIf="row.status == 'deactive'">check</mat-icon>
                </button>
                <button mat-raised-button color="primary" (click)="update(row.id, row.Role)">
                    <mat-icon>update</mat-icon>
                </button>
                <button mat-raised-button color="primary" (click)="settings(row.id, row.Role)">
                  <mat-icon>build</mat-icon>
                </button>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="tableColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: tableColumns"></mat-row>
    </mat-table>
    <mat-form-field style="width: 100%" *ngIf="update_web == 'true' || update_web == 'new'">
        <input style="width: 100%" matInput placeholder="Role" [(ngModel)]="name_web" value="name_web">
    </mat-form-field>
    <br>
    <br>
    <button *ngIf="update_web == 'true'" mat-raised-button color="primary" (click)="save()">
            <mat-icon>save</mat-icon>
    </button>
    <button *ngIf="update_web == 'new'" mat-raised-button color="primary" (click)="savenew()">
            <mat-icon>save</mat-icon>
    </button>
</mat-card>
<br>
<mat-card  *ngIf="update_settingweb == 'true'" class="example-card" style="width: 100%; background-color: rgb(153, 218, 238)">
  <br>
  <h1 style="text-align: center;">{{this.namesetting}}</h1>
<br>
  <table style="width: 100%; background-color: white;">

    <tr style="text-align: center;">
      <th style="text-align: center;"> Employee </th>
      <th style="text-align: center;"> Availability </th>
      <th style="text-align: center;"> Summary </th>
      <th style="text-align: center;"> Timesheet </th>
      <th style="text-align: center;"> Internal Settings </th>
      <th style="text-align: center;"> Training </th>
      <th style="text-align: center;"> Admin </th>
      </tr>
      <tr  style="text-align: center;">
      <td><mat-checkbox  [(ngModel)]="Employee"></mat-checkbox> </td>
      <td> <mat-checkbox  [(ngModel)]="Availability"></mat-checkbox> </td>
      <td> <mat-checkbox  [(ngModel)]="Summary"></mat-checkbox> </td>
      <td> <mat-checkbox  [(ngModel)]="Timesheet"></mat-checkbox> </td>
      <td> <mat-checkbox  [(ngModel)]="Internal_Settings"></mat-checkbox> </td>
      <td> <mat-checkbox  [(ngModel)]="Training"></mat-checkbox> </td>
      <td> <mat-checkbox  [(ngModel)]="Admin"></mat-checkbox> </td>
    </tr>
    <tr></tr>
    <tr >
      <th style="text-align: center;"  colspan="6">
        <button  mat-raised-button color="primary" (click)="savesettings()">
          <mat-icon>save</mat-icon>
  </button>
      </th>
    </tr>
    </table>
  <br>
</mat-card>
<br> <br>
